import { memo, useEffect } from 'react';
import { useDispatch, useListeners } from '@client/hooks/redux.hooks';
import { allUsersListeners } from '@client/components/Main/common/all-users.listeners';
import { loadCategories } from '@client/slices/entities/categories.reducer';
import { useGoogleAnalyticsClientId } from '@client/hooks/useGoogleAnalyticsClientId';

export const AllUsersListeners = memo(() => {
  const dispatch = useDispatch();
  useGoogleAnalyticsClientId();

  useListeners(allUsersListeners);

  useEffect(() => {
    dispatch(loadCategories());
  }, [dispatch]);

  return null;
});
